import React from 'react'
import {Component} from 'react'
import './event-sponsor-section.scss'

export default class SponsorSection extends Component {
  render(){
    return ( 
      <span>
      {
        this.props.image && this.props.link.url &&  <div className='event-sponsor-section'>
         <div className='event-sponsor-section__img'>
          <img src={this.props.image} />
        </div>
        <div className='event-sponsor-section__img mobile'>
          <img src={this.props.mobile_image} />
        </div> 
        <div className='event-sponsor-section__cta'>
          <p>{this.props.text} <br /><a target={ this.props.link.target } href={ this.props.link.url }>{ this.props.link.title }</a></p>
        </div> 
        
        </div> 
      }
      </span>
    )
  }
}
